import { rangeOf, type RangeName } from '../easeedesk/dashboards/range'
import { PeriodFilter } from '../securitee/DevicesPage'
import type { Period } from '../api/securitee'

/**
 * Selectorul de perioada al modulului Productivitee: scurtaturile
 * daterangepicker-ului din `ProductiviteeUserPeriodSummary`
 * (public/js/productivitee.js), fara `Last 24 Hours` - listele sunt pe zile -
 * si `Custom range`, adica cele doua casute de date.
 *
 * Statea in `Pages.tsx`, langa singura lista care il folosea. Fila Evolution
 * din randul desfacut si tabloul de conducere il cer si ele, iar `Pages.tsx`
 * incarca `Tabs.tsx`: lasat acolo, ar fi facut un cerc de module
 * (Pages -> Tabs -> fila -> Pages). Aici nu incarca nimic din modul, deci
 * oricine il poate cere. `Pages.tsx` il da mai departe, ca probele si
 * importurile scrise pana acum sa ramana valabile.
 */
export const PERIOD_PRESETS: RangeName[] = ['Today', 'Yesterday', 'Last 7 Days', 'Last 30 Days', 'This Month', 'Last Month']

export function PeriodWithPresets({ period, onChange }: { period: Period; onChange(p: Period): void }) {
  const chosen = PERIOD_PRESETS.find((name) => {
    const r = rangeOf(name)
    return r.from.slice(0, 10) === period.from && r.to.slice(0, 10) === period.to
  }) ?? ''
  return (
    <span style={{ display: 'inline-flex', gap: 6, alignItems: 'center' }}>
      <select className="form-control input-sm" aria-label="Period" value={chosen} onChange={(e) => {
        if (!e.target.value) return
        const r = rangeOf(e.target.value as RangeName)
        onChange({ from: r.from.slice(0, 10), to: r.to.slice(0, 10) })
      }}>
        <option value="">Custom range</option>
        {PERIOD_PRESETS.map((name) => <option key={name} value={name}>{name}</option>)}
      </select>
      <PeriodFilter period={period} onChange={onChange} />
    </span>
  )
}
